module.exports = __webpack_public_path__ + "c9ed79e7e255e0d9438ad56a48bb6de0.svg";